import type { StepRankMe } from "@/lib/types";
import { formatKm, formatNumber, medalFor, rankLabel } from "../utils";

interface Props {
  me: StepRankMe;
  /** 공개 전환 진행 중 */
  saving?: boolean;
  onTogglePublic?: () => void;
}

// 목록 위에 항상 띄우는 «내 순위» 고정 바.
// 내가 100위 밖이어도 여기에는 나온다.
export default function StepMyBar({ me, saving, onTogglePublic }: Props) {
  const rank = Number(me.rank ?? 0);
  const isPublic = Number(me.public ?? 0) === 1;
  const medal = medalFor(rank);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-primary-200 bg-primary-50 px-4 py-3.5 md:px-5">
      <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
        <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-semibold text-background-50">
          내 순위
        </span>
        <span className="font-heading text-lg font-bold tabular-nums text-foreground-950">
          {medal ? `${medal} ` : ""}
          {rankLabel(rank)}
        </span>
        <span className="text-sm font-semibold text-foreground-800">{me.name}</span>
        <span className="text-sm tabular-nums text-foreground-600">
          {formatNumber(me.steps)}보
        </span>
        {typeof me.km === "number" && (
          <span className="text-sm tabular-nums text-foreground-500">{formatKm(me.km)}km</span>
        )}
      </div>

      {!isPublic && (
        <button
          type="button"
          onClick={onTogglePublic}
          disabled={saving}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-xs font-semibold text-foreground-600 hover:bg-background-100 disabled:opacity-60"
        >
          <i className="ri-eye-off-line" aria-hidden="true"></i>
          비공개
        </button>
      )}
    </div>
  );
}